import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Progress } from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  userIsAdmin,
  userIsManager,
} from '../helpers/Auth';
import { formatBytes } from '../helpers/Files';
import { getSetting } from '../helpers/Settings';

const SidebarSpaceUsage = ({ profile }) => {
  const intl = useIntl();

  if (
    !profile ||
    !profile.client ||
    profile.client.hide_usage ||
    getSetting('cs1')
  ) {
    return null;
  }

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <div className="sidebar-space-usage">
      <Progress
        value={profile.client.used_storage_percentage}
      />
      <span>
        {intl.formatMessage(
          { defaultMessage: '{usedStorage} of {totalStorage} used' },
          {
            usedStorage: formatBytes(profile.client.used_storage),
            totalStorage: formatBytes(profile.client.file_size_limit),
          },
        )}
      </span>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

SidebarSpaceUsage.propTypes = {
  profile: PropTypes.object,
};

SidebarSpaceUsage.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(SidebarSpaceUsage);
